import { useMemo } from 'react';
import { Price } from 'src/types';
import { VariantValues } from '../types';

export const useVariantValues = (offers: Price[]): VariantValues => {
  return useMemo(() => {
    const sizes = new Set<string>();
    offers.forEach(offer => {
      if (offer?.variantInfo?.size) {
        sizes.add(offer.variantInfo.size);
      }
      offer.alternativePrices?.forEach(alt => {
        if (alt?.variantInfo?.size) {
          sizes.add(alt.variantInfo.size);
        }
      });
    });
    return { sizes: [...sizes] };
  }, [offers]);
};
